import { createFileRoute } from '@tanstack/react-router'

import { IncomePage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/income',
)({
  component: IncomePage,
})
